import SidepanelLayout from './SidepanelLayout';

export default SidepanelLayout;
